export * from './blogPage.component'
